// extracted by mini-css-extract-plugin
export default {"common_input_styles":"SupportingDocuments_common_input_styles__a3tFB","uploadLabel":"SupportingDocuments_uploadLabel__GxiZf"};